'use strict';

export class Order
{
    constructor( options = [])
    {
        this.options = options
        this.init()
    }

    init()
    {
        const instance = this

        $('[data-radio="deliveries"]').on('click', function(e){
            instance.deliveryChange($(this))
        });

        $('[data-radio="person_types"]').on('click', function(e){
            instance.personTypeChange($(this))
        });

        let deliveryId = $('.js-order-delivery:checked').data('delivery-id')
        $('[name="shipment"]').val(deliveryId)

        $(document).on('submit', '.form-ajax', function(e) {
            if ($(this).find('[type="submit"]').length > 0) {
                e.preventDefault();
                let form = $(this);
                instance.orderAjax($(form))
                // showOrderPopupMsg({title: BX.message('ORDER_SUCCESS_TITLE'),text: BX.message('ORDER_SUCCESS_DESCRIPTION'), btn_text: BX.message('ORDER_SUCCESS_BTN')})
                showPopupMsg({title: BX.message('ORDER_SUCCESS_TITLE'),text: BX.message('ORDER_SUCCESS_DESCRIPTION')})
            }
        });
    }

    orderAjax(form)
    {
        let data = form.serialize();
        let url = '/cart/';
        let type = form.attr('method');
        $.ajax({
            url: url,
            type: type,
            data: data,
            success: function (result) {
                ym(5592460,'reachGoal','pravilno-zapolnil-nazal-oformit-zakaz') 
                // showPopupMsg({title: BX.message('ORDER_SUCCESS_TITLE'),text: BX.message('ORDER_SUCCESS_DESCRIPTION')})
            }
        });

    }

    deliveryChange(el)
    {
        let deliveryId = el.find('[data-delivery]').data('delivery-id')
        $('[name="shipment"]').val(deliveryId)
    }

    personTypeChange(el)
    {
        let personTypeId = el.find('[data-person-type]').data('person-type-id')
        $('[name="person_type"]').val(personTypeId)
    }

    getPersonAjax (id)
    {
        $.ajax({
            url: '/personal/order/?PROFILE_ID='+id,
            success : function(data) {
                $(".order__inputs.delivery").html($(data).find(".order__inputs.delivery").html());
            }
        })
    }

}